import { apiSlice } from "../../../app/apiSlice";
import configUrls from "../../../config/configUrls";
import { DocumentoAtualizaAndamentoDTO } from "../../../types/documento/andamentoHistorico/DocumentoAtualizaAndamentoDTO";
import { DocumentoHistoricoAndamentoList } from "../../../types/documento/andamentoHistorico/DocumentoHistoricoAndamentoList";


const endpointUrl = configUrls.DOCUMENTO_HISTORICO_EP;

type Search = {
    id: string;
    search: string;
};



function getDocumentoHistoricos({ id, search }: Search) {
    if (!id) {
        // Se 'documento' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/historico/${id}?search=${search}`,
        method: "GET",
    }
}

function atualizarHistoricoDocumento(obj: DocumentoAtualizaAndamentoDTO) {
    return {
        url: `${endpointUrl}/historico`,
        method: "POST",
        body: obj,
    }
}

export const documentoAtualizarAndamentoApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({

        getDocumentoHistoricos: query<DocumentoHistoricoAndamentoList[], { id: string, search: string }>({
            //query: (id) => `${endpointUrl}/ciencia/${id}`,
            query: getDocumentoHistoricos,
            providesTags: ["Documento"],
        }),

        addDocumentoHistorico: mutation<void, DocumentoAtualizaAndamentoDTO>({
            query: atualizarHistoricoDocumento,
            invalidatesTags: ["Documento"]
        }),

    }),

});
export const {
    useAddDocumentoHistoricoMutation,
    useGetDocumentoHistoricosQuery,
} = documentoAtualizarAndamentoApiSlice